import { graphql, useStaticQuery } from "gatsby";

const GET_HOME_DATA = graphql`
  query GetHomeData {
    wpPage(id: { eq: "cG9zdDoyNTY=" }) {
      home {
        statisticHomeRepeater {
          homeNumber
          homeTitle
        }
      }
    }
  }
`;

export const useHomeData = () => {
  const data = useStaticQuery(GET_HOME_DATA);
  return data.wpPage.home.statisticHomeRepeater;
};
